import { jsx as e, jsxs as n } from "react/jsx-runtime";
import t from "./Callout.js";
import r from "./LinkWithButtonStyles.js";
const l = () => /* @__PURE__ */ e(
  t,
  {
    className: "container-xl rounded-xl [&>:first-child]:max-w-[30ch]",
    heading: "Ready to earn while helping developers gain hands-on project experience?",
    theme: "light",
    children: /* @__PURE__ */ n("div", { className: "container-md flex flex-col items-center gap-6", children: [
      /* @__PURE__ */ e("p", { className: "max-w-prose text-lg text-neutral-500", children: "Apply now and start earning commissions for sharing Frontend Mentor’s platforms with your community and network." }),
      /* @__PURE__ */ e(r, { href: "https://partners.frontendmentor.io", children: "Apply now" })
    ] })
  }
);
export {
  l as default
};
